import partial from 'lodash/partial'

import {fsa, fsaPayloadByKeys, gateAction} from '../helpers'
import {MODALS} from './enums'

import * as userInteractions from '../../store/userInteractions'

// -- Actions

// Zendesk

export const HIDE_ZENDESK = 'zendesk/hide'
export const hideZendesk = fsa(HIDE_ZENDESK)

export const SHOW_ZENDESK = 'zendesk/show'
export const showZendesk = fsa(SHOW_ZENDESK)

// Modal

export const OPEN_MODAL = 'open the modal component'
export const openModal = fsaPayloadByKeys(OPEN_MODAL, ['id'])

export const CLOSE_MODAL = 'close the modal component'
export const closeModal = fsa(CLOSE_MODAL)

// Specific modals

export const openAddressUpdateErrorModal = partial(openModal, MODALS.ADDRESS_UPDATE_ERROR)
export const openAddressValidationModal = partial(openModal, MODALS.ADDRESS_VALIDATION)
export const openBuyEditOrderErrorModal = partial(openModal, MODALS.BUY_EDIT_ORDER_ERROR_MODAL)
export const openParticipantPermissionModal = partial(
  openModal,
  MODALS.PARTICIPANT_PERMISSION_MODAL,
)
export const openCheckoutErrorModal = partial(openModal, MODALS.CHECKOUT_ERROR)
export const openCheckoutPromptModal = partial(openModal, MODALS.CHECKOUT_PROMPT)
export const openDoubleConfirmModal = partial(openModal, MODALS.DOUBLE_CONFIRM)
export const openSuccessModal = partial(openModal, MODALS.SUCCESS_MODAL)
export const openCustomerCareTicketModal = partial(openModal, MODALS.CUSTOMER_CARE_TICKET_MODAL)
export const openErrorModal = partial(openModal, MODALS.ERROR_MODAL)
export const openErrorHelpCenterModal = partial(openModal, MODALS.ERROR_HELP_CENTER_MODAL)
export const openEventMgrCancelParticipantModal = partial(
  openModal,
  MODALS.EVENT_MGR_CANCEL_PARTICIPANT,
)
export const openFitErrorModal = partial(openModal, MODALS.FIT_ERROR_MODAL)
export const openFitGuaranteeModal = partial(openModal, MODALS.FIT_GUARANTEE)
export const openFunctionalRuleModal = partial(openModal, MODALS.FUNCTIONAL_RULE)
export const openLookbuilderRemoveItemModal = partial(openModal, MODALS.LOOKBUILDER_REMOVE_ITEM)
export const openLookbuilderRentOrBuyModal = partial(openModal, MODALS.LOOKBUILDER_RENT_OR_BUY)
export const openPdpErrorModal = partial(openModal, MODALS.PDP_ERROR)
export const openRecommendationModal = partial(openModal, MODALS.RECOMMENDATION_MODAL)
export const openRentVsBuyModal = partial(openModal, MODALS.RENT_VS_BUY)
export const openRtkCheckoutErrorModal = partial(openModal, MODALS.RTK_CHECKOUT_ERROR)
export const openTimeToEventErrorModal = partial(openModal, MODALS.TIME_TO_EVENT_ERROR_MODAL)
export const openPrintReturnLabelModal = partial(openModal, MODALS.PRINT_RETURN_LABEL)

export const HIDE_PASSWORD_RESET_REQUEST_FORM = 'hide the password reset request form'
export const HIDE_PASSWORD_RESET_REQUEST_SUCCESS = 'hide the password reset request success'
export const OPEN_CONFIRM_MODAL = 'open confirmation modal'

interface OpenConfirmActionPayload {
  className: string
  confirmText: string
  confirmAction: () => void
  question: React.ReactNode
  cancelText?: string
}

export const openConfirmModal = (
  payload: OpenConfirmActionPayload,
): {type: string; payload: OpenConfirmActionPayload} => ({
  type: OPEN_CONFIRM_MODAL,
  payload,
})

export const SHOW_PASSWORD_RESET_REQUEST_FORM = 'show the password reset request form'
export const showPasswordResetRequestForm = fsa(SHOW_PASSWORD_RESET_REQUEST_FORM)

export const SHOW_PASSWORD_RESET_REQUEST_SUCCESS = 'show the password reset request success'

// -- Thunks

export const CLOSE_CONFIRM_MODAL = 'close confirmation modal'
export const _closeConfirmModal = fsa(CLOSE_CONFIRM_MODAL)
export const closeConfirmModal = gateAction(_closeConfirmModal, userInteractions.confirmModalIsOpen)
